import { useIndexPrice } from 'app/hooks/trade/indexprice'
import BigNumber from 'bignumber.js'
import React from 'react'
import { useInfo24H } from '../../../hooks/trade/info24H'
import { useTradeStore } from '../../../hooks/trade/tradeStore'
import DefaultKrw from './DefaultKrw'

const CurrentPrice = () => {
	const { symbol, dp } = useTradeStore()
	const { data: info24 } = useInfo24H(symbol)
	const { getPrice } = useIndexPrice(symbol)

	const currentprice = BigNumber(getPrice(symbol) || info24?.open || 0)

	const beforeclose = BigNumber(info24?.open).minus(info24?.change).toNumber()
	return (
		<DefaultKrw
			title={'현재가'}
			price={currentprice.toNumber()}
			dp={dp}
			comma={false}
			krw={false}
			color={true}
			colordiff={
				beforeclose < currentprice.toNumber()
					? 'up'
					: beforeclose > currentprice.toNumber()
					? 'down'
					: 'same'
			}
		/>
	)
}

export default React.memo(CurrentPrice)
